// temporary resources as png, not svg unti we receive better assets

const staticImages = {
  arrowRightBlue: require('./images/right-arrow.png').default,
  arrowRightWhite: require('./images/right-arrow-white.png').default,
  backgroundSquares: require('./images/background-squares.png').default,
  bubble: require('./images/bubble.png').default,
  logo: require('./images/logo.png').default,
  registerPlaceholder: require('./images/register-background.png').default,
  defaultAvatar: require('./images/roomsyncBlankAvatar_1.png').default,
  communityBackground: require('./images/community-header-bg.png').default,
  demoLeft: require('./images/demo_card_left.png').default,
  demoRight: require('./images/demo_card_right.png').default,
  bannerLogo: require('./images/banner-logo.jpg').default,
  googleButton: require('./images/google-button.png').default,
  facebokButton: require('./images/facebook-button.png').default
}

export default staticImages
